import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Box,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router";
import GST from "../../assets/GST-Compliance.jpg";
import instant from "../../assets/Instant-E-invoicing.jpg";
import Quick from "../../assets/Quick-Data-Access.jpg";
import Inventory from "../../assets/Inventory-Tracking.jpg";
import Easy from "../../assets/Easy-Financial-Reports.jpg";
import Revievables from "../../assets/Receivable-And-Payables.jpg";
import Currency from "../../assets/Currency-Flexible-Bills.jpg";
import Tailored from "../../assets/Customizable-Templates.jpg";
const ProductSlider = () => {
  const navigate = useNavigate();
  const [Cards, setCards] = useState([]);
  const handlecardClicks = (slug) => {
    navigate(`/podsdetails/${slug}`);
  };

  const lists2 = [
    {
      id: "1",
      title: "GST compliance",
      description:
        "Our software effortlessly identifies the applicable GST components - CGST, SGST, or IGST, streamlining financial management. It automates tax compliance tasks such as generating invoices and processing e-way bills, making the process smoother for hassle-free GST management.",
      bgcolor: "white",
      src: GST,
    },
    {
      id: "2",
      title: "Instant E-Invoicing",
      description:
        "With a single click, our software empowers businesses to swiftly produce invoice reference numbers (IRNs) and QR codes. This efficient method simplifies the process of invoice generation, saving businesses from dealing with lots of steps or long procedures. Our interface enables instant creation of IRNs and QR codes.",
      bgcolor: "#C2FFD3",
      src: instant,
    },

    {
      id: "3",
      title: "Quick Data Access",
      description:
        "Access your data quickly and effortlessly with our software, ensuring easy usage across any device and location. With unmatched dependability and maximum up-time, users can consistently access their data whenever needed. Experience instant access without delays using our reliable and user-friendly software solution.",
      src: Quick,
    },
    {
      id: "4",
      title: "Inventory Tracking",
      description:
        "Our software helps businesses automatically update their inventory, making sure they always know exactly what they have in stock. This real-time tracking feature empowers businesses to make informed choices regarding stock control and product availability.",
      bgcolor: "#052973",
      src: Inventory,
    },
    {
      id: "5",
      title: "Easy Financial Reports",
      description:
        "This software effortlessly generates detailed financial reports, providing valuable insights into expenditure patterns such as income, expenses, profits and losses. It also helps you in budget planning and spending money wisely. With these reports, you can make smart decisions to improve your finances.",
      src: Easy,
    },
    {
      id: "6",
      title: "Receivable and Payables",
      description:
        "It simplifies the management of receivables and payables, empowering users to oversee accounts efficiently. You can quickly create professional invoices and quotes, offering diverse payment methods. Automation features ensure seamless tracking of vendor bills and expenses, while income statements and balance sheets provide accurate financial insights.",
      bgcolor: "#F15B25",
      src: Revievables,
    },
    {
      id: "7",
      title: "Currency-flexible Bills",
      description:
        "Sanniro offers multi-currency support, making international transactions seamless. It can generate invoices in various currencies, and also you can manage your foreign transactions in an easy way. You can apply exchange rates automatically or manually to ensure accurate billing and financial tracking.",
      src: Currency,
    },
    {
      id: "8",
      title: "Tailored Options",
      description:
        "You can tailor the software to fit your business perfectly with customizable templates and reports. Choose from a variety of options, including templates, fonts, and colours, to create fully personalised invoices, whether GST or non-GST. Saniiro BAIMS is completely customizable to meet your unique business requirements.",
      src: Tailored,
    },
  ];
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 600 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1.2,
    },
  };
  return (
    <Stack
      sx={{ width: { lg: "90%", xs: "93%" }, margin: 4 }}
      display={{ md: "none", sm: "flex" }}
    >
      <Carousel
        responsive={responsive}
        arrows={false}
        style={{
          display: "flex",
          gap: "20px",
        }}
      >
        {lists2.map((d) => (
          <Stack
            key={d.id}
            className="content"
            border={"1px solid lightgrey"}
            borderRadius={5}
          >
            <Stack
              minHeight={0}
              gap={1}
              id={`item${d.id}`}
              className="item"
              alignItems={"flex-start"}
            >
              <Typography fontWeight={"bold"} fontSize={"18px"} color={"black"}>
                {d.title}
              </Typography>
              <Typography
                textAlign={"justify"}
                color={"grey"}
                fontSize={{ xl: "16px", sm: "13px" }}
                height={"198px"}
              >
                {d.description}
              </Typography>
              <Stack>
                <img src={d.src} alt="" width={"100%"} height={"100%"} />
              </Stack>
            </Stack>
          </Stack>
        ))}
      </Carousel>
    </Stack>
  );
};

export default ProductSlider;
